import styled from "styled-components";
import { borderRadius, borderWidth, spacing, typographyMixin } from "@magicbi/ui-library";

export const Panel = styled.section`
  width: 25rem;
  max-width: calc(100vw - 2rem);
  background: ${({ theme }) => theme.colors.surface.primary};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Head = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[2]};
  min-height: 3.25rem;
  padding: ${spacing[2]} ${spacing[2]} ${spacing[2]} ${spacing[4]};
  background: ${({ theme }) => theme.colors.surface.primary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.stroke};
`;

export const Title = styled.h2`
  margin: 0;
  ${typographyMixin("subtitle", 2)}
`;

export const Entries = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Entry = styled.li`
  display: grid;
  grid-template-columns: 2rem minmax(0, 1fr) 0.5rem;
  column-gap: ${spacing[3]};
  padding: ${spacing[3]} ${spacing[4]};
  border-top: 1px solid ${({ theme }) => theme.colors.border.stroke};

  &:first-child {
    border-top: 0;
  }
`;

export const Text = styled.div`
  min-width: 0;
`;

export const EntryTitle = styled.p`
  margin: 0;
  ${typographyMixin("body", 2)}
  overflow-wrap: anywhere;
`;

export const EntryBody = styled.p`
  margin: ${spacing[0.5]} 0 0;
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
  overflow-wrap: anywhere;
`;

export const Meta = styled.p`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[2]};
  margin: ${spacing[1]} 0 0;
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const LinkButton = styled.button`
  padding: 0;
  border: 0;
  background: none;
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.text.link};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: ${borderWidth[2]} solid ${({ theme }) => theme.colors.interactive.primary};
    border-radius: ${borderRadius.sm};
  }
`;

export const Dot = styled.span<{ $error: boolean }>`
  width: 0.5rem;
  height: 0.5rem;
  margin-top: ${spacing[3]};
  border-radius: ${borderRadius.full};
  background: ${({ theme, $error }) => ($error ? theme.colors.error[500] : theme.colors.interactive.primary)};
`;

export const Empty = styled.div`
  display: grid;
  justify-items: center;
  gap: ${spacing[1]};
  padding: ${spacing[6]} ${spacing[6]} ${spacing[8]};
  text-align: center;
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};

  b {
    ${typographyMixin("body", 2)}
    color: ${({ theme }) => theme.colors.text.primary};
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
    color: ${({ theme }) => theme.colors.interactive.primary};
  }
`;
